import script from "./CallAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./CallAvatar.vue?vue&type=script&setup=true&lang=js"

import "./CallAvatar.vue?vue&type=style&index=0&id=1e7760e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7760e1"]])

export default __exports__